angular.module("workflow.app")
  .factory "RiskScore", ($http, endpoints) ->

    return {
      calculate: (entityID, callback) ->
        # .success(), and .error() will be deprecated in the future.
        # However, using .then() means that `data` doesn't actually contain the
        # serialized "data" that we need.
        $http.get(endpoints.CalculateRiskScore, {"params": {entity: entityID}})
          .then(
            (data, status, headers, config) ->
              if data.data.risk_score?
                callback "", data.data.risk_score
              else
                callback "Error calculating risk score", -1
            , (data, status, headers, config) ->
              callback "Error calculating risk score", -1
          )
    }
